<mcg-window
  #formAssociate
  [loading]="loading()"
  [title]="translate('Asociacion_ecolock_calendario')"
  [actions]="actions"
  (actionButtonClicked)="actionButtonClicked($event)"
  (windowClosed)="onClose()"
>
  <div style="width: 100%; height: calc(100% - 30px); display: flex; flex-direction: row; gap: 15px;">
    <div style="width:40%">
      <div>
        {{ calendarsTitle() }}
      </div>
      <jqxGrid #gridCalendar [theme]="theme" [width]="'100%'" [height]="'calc(100% - 20px)'" [source]="dataAdapter"
        [columnsresize]="true" [localization]="langGrid" [filterable]="true" [columns]="columnCalendar" [appCellClick]
        [enablebrowserselection]="true" [columnmenuopening]="columnmenuopening" [showrowlines]="false" [showcolumnlines]="true"
        [pageable]="false" [sortable]="true" [altrows]="true" [rowsheight]="20" [columnsheight]="20" [editable]="false"
        [columnsresize]="true" (onBindingcomplete)="onGridCalendarDataUpdated()" (onRowclick)="onRowClick($event.args.rowindex)"
        [filter]="filter" [updatefilterconditions]="updatefilterconditions" (onFilter)="onGridCalendarDataUpdated()">
      </jqxGrid>
    </div>
    <div style="width:60%;">
      <div>
        {{ lockTitle() }}
      </div>
      <jqxGrid id="grid1" #myGridLock [theme]="theme" [width]="'100%'" [height]="'calc(45% - 20px)'" [appCellClick]
        [source]="dataAdapterLock" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
        [enablebrowserselection]="true" [columns]="columnLock" [showrowlines]="false" [showcolumnlines]="true"
        [pageable]="false" [sortable]="true" [altrows]="true" [statusbarheight]="20" [showstatusbar]="true"
        [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [editable]="false" [selectionmode]="'checkbox'"
        [filter]="filter" [updatefilterconditions]="updatefilterconditions" (onRowselect)="onSelectV2($event.args, 'grid1')"
        (onRowunselect)="onUnSelect($event.args)" (onBindingcomplete)="onGridLockDataUpdated()" (onFilter)="onGridLockDataUpdated()">
      </jqxGrid>
      <div style="display: flex; flex-direction: column; margin-left: 42%; height: 10%;">
        <div>
          <jqxButton style="float:left; clear: both; margin-right: 6px;" [width]='25' [height]='26'
            [textImageRelation]='"imageAfterText"' [textPosition]='"left"' [imgPosition]='"right"'
            [imgSrc]='"/assets/images/arriba.png"' (onClick)="onMasClick()">
          </jqxButton>
          <jqxButton style="gap: 5px;" [width]='25' [height]='26' [textImageRelation]='"imageBeforeText"'
            [textPosition]='"right"' [imgPosition]='"left"' [imgSrc]='"/assets/images/abajo.png"'
            (onClick)="onMenosClick()">
          </jqxButton>
        </div>
      </div>
      <div>
        {{ lockFreeTitle() }}
      </div>
      <jqxGrid id="grid2" #myGridLockFree [theme]="theme" [width]="'100%'" [height]="'calc(45% - 20px)'"
        [appCellClick] [source]="dataAdapterLockFree" [columnsresize]="true" [localization]="langGrid"
        [filterable]="true" [columns]="columnLock" [showrowlines]="false" [showaggregates]="true"
        [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true"
        [statusbarheight]="20" [rowsheight]="20" [columnsheight]="20" [editable]="false" [selectionmode]="'checkbox'"
        [enablebrowserselection]="true" [filter]="filter" [updatefilterconditions]="updatefilterconditions"
        (onRowselect)="onSelectV2($event.args, 'grid2')" (onRowunselect)="onUnSelect($event.args)"
        (onBindingcomplete)="onGridLockFreeDataUpdated()" (onFilter)="onGridLockFreeDataUpdated()">
      </jqxGrid>
    </div>
  </div>
</mcg-window>
